import * as React from 'react';
import { useLanguageLocale } from '../../hooks/language-locale-hooks';

import { DataIndicators } from '../DataIndicators';
import { isDataLoaded } from '../../types';
import { useDeviceData } from '../../data/DataProviders/DeviceDataProvider';
import { TimelineDetailPage } from '../TimelineDetailPage';
import { AppRoute } from '../../routes';
import { SignalRSiteDataProvider } from '../../data/DataProviders/SignalRSiteDataProvider';
export type Props = {
    appRoute: AppRoute;
    testId: string;
};
export const TimelineDetailPageContainer: React.FC<Props> = (props) => {
    const { t } = useLanguageLocale();
    const deviceDetailsData = useDeviceData();
    const locationId =
        props.appRoute.type === 'OverviewSite' ||
        props.appRoute.type === 'TimelineLocation' ||
        props.appRoute.type === 'OverviewSiteTimeline'
            ? props.appRoute.locationId
            : undefined;
    return (
        <>
            <DataIndicators
                emptyIcon="Notifications"
                emptyMessage={t('DASHBOARD.EVENT_NOT_FOUND')}
                errorMessage={t('DASHBOARD.ERROR_LOADING_EVENT')}
                data={deviceDetailsData}
                isEmpty={false}
            />
            {isDataLoaded(deviceDetailsData) && isDataLoaded(deviceDetailsData.value.deviceProperties) && (
                <SignalRSiteDataProvider
                    siteId={deviceDetailsData.value.deviceProperties.value.siteId}
                    locationId={locationId}
                >
                    <TimelineDetailPage testId={props.testId} appRoute={props.appRoute} />
                </SignalRSiteDataProvider>
            )}
        </>
    );
};
